<template>
  <div class="cbg-white-container input-container theme--light v-card p-16 border-card">
    <div class="col-sm-12 row ml-0 pl-0 pr-0">
      <div class="row">
        <div class="form-group col-sm-6 col-md-3 common-search position-relative">
          <label for>Filter</label>
          <div class="search-div position-relative">
            <input
              type="text"
              placeholder="Search"
              @keyup="getRedFlagList"
              v-model="search"
              class="form-control"
            />
            <div v-if="search !== ''" class="search-svg position-absolute" @click="clearSearch()">
              <crossSVG />
            </div>
          </div>
        </div>
        <div class="form-group col-sm-6 col-md-3">
          <div class="position-relative">
            <label for>Status</label>
            <select name id class="form-control" v-model="status">
              <option value="all">All</option>
              <option value="approved">Approved</option>
              <option value="declined">Rejected</option>
              <option value="pending">Pending</option>
              <option value="cancelled_after_approval">Cancelled</option>
            </select>
            <span class="drop-icon">
              <i aria-hidden="true" class="v-icon mdi mdi-menu-down theme--light position-absolute"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="table-div mb-ov-auto">
      <table class="table userlistTable table-width userlistTable-typ1">
        <thead>
          <tr class="table-success">
            <th>Patient name</th>
            <th>UUID</th>
            <th>Doctor name</th>
            <th>Requested On</th>
            <th>Status</th>
            <!-- <th>Pending</th> -->
            <th></th>
          </tr>
        </thead>
        <tbody v-for="(item, index) in redFlagList" :key="index">
          <tr>
            <td class="text-capitalize">
              {{ item.raised_against.first_name }}
              {{ item.raised_against.last_name }}
            </td>
            <td>{{ item.raised_against.uuid }}</td>
            <td
              class="text-capitalize"
            >{{ item.raised_by.first_name }} {{ item.raised_by.last_name }}</td>
            <td>{{ dayJS(item.created_at).format(formats.date_format) }}</td>
            <td>{{ `${item.status} at ${dayJS(item.updated_at).format(formats.date_time_format)}` }}</td>

            <td>
              <v-btn class="btn btn-primary" @click="toggleDetails(item, index)">View</v-btn>
            </td>
          </tr>
          <tr class="collaps-tr card-buttons">
            <td colspan="6" class="col-sm-12 border-0">
              <CCollapse
                class="col-sm-12 p-0"
                :show="indexOfCollapse[index]"
                :duration="collapseDuration"
              >
                <CCardBody class="col-sm-12 p-0">
                  <v-btn
                    size="sm"
                    class="btn btn-danger ml-1"
                    v-if="item.status == 'pending' && permissions.includes('CAN_APPROVE_REJECT_RED_FLAG_REQUEST')"
                    @click="setRedFlagStatus(item, 'reject')"
                  >Reject</v-btn>
                  <v-btn
                    size="sm"
                    class="btn btn-danger ml-1"
                    v-if="item.status == 'approved'"
                    @click="revokeToggle(index, true)"
                  >Revoke Red Flag</v-btn>
                  <v-btn
                    size="sm"
                    color="danger"
                    class="btn btn-success ml-1"
                    v-if="item.status == 'pending' && permissions.includes('CAN_APPROVE_REJECT_RED_FLAG_REQUEST')"
                    @click="openSwal(item, 'approve')"
                  >Approve</v-btn>

                  <v-btn
                    size="sm"
                    class="btn btn-primary ml-1"
                    v-if="permissions.includes('CAN_VIEW_INFORMATION_RED_FLAG_REQUEST')"
                    @click="onFirModal(item, index)"
                  >View FIR</v-btn>
                  <v-btn
                    size="sm"
                    class="btn btn-primary ml-1"
                    v-if="permissions.includes('CAN_VIEW_INFORMATION_RED_FLAG_REQUEST')"
                    @click="openInformationDisplay('View Information')"
                  >View Information</v-btn>
                  <v-btn
                    size="sm"
                    class="btn btn-primary ml-1"
                    @click="damageModal(item, index)"
                    v-if="item.pictures_of_damage.length > 0 && permissions.includes('CAN_VIEW_INFORMATION_RED_FLAG_REQUEST')"
                  >View Damages</v-btn>

                  <v-btn
                    size="sm"
                    class="btn btn-primary ml-1"
                    @click="openInformationDisplay('Reason')"
                    v-if="item.status==='declined'"
                  >Reason</v-btn>

                  <v-btn size="sm" class="btn btn-primary ml-1" @click="goToChat(item._id)">Chat</v-btn>

                  <v-btn
                    size="sm"
                    class="btn btn-primary ml-1"
                    @click="openInformationDisplay('Call')"
                  >Call</v-btn>

                  <v-btn
                    size="sm"
                    class="btn btn-primary ml-1"
                    @click="openInformationDisplay('Email')"
                  >Email</v-btn>

                  <div>
                    <CModal title="Document/Certificate" color="dark" :show.sync="filePdf">
                      <span v-for="(value, index) in item.fir_url" :key="index">
                        <pdf-component
                          :src="value"
                          :styles="'width: 100%; height: 800px'"
                          v-if="filePdf"
                        ></pdf-component>
                      </span>
                      <template #footer>
                        <v-btn @click="filePdf = false" class="btn btn-danger">Cancel</v-btn>
                      </template>
                    </CModal>

                    <!-- vue information and reason modal start-->
                    <CModal title="Description" color="dark" :show.sync="informationDisplay">
                      <div v-if="titleName==='Reason'">
                        <div class="col-sm-12">
                          <h5>Reason:</h5>
                          <h6>
                            {{
                            item.status_history_recent.remark
                            }}
                          </h6>
                        </div>
                      </div>
                      <div v-else-if="titleName==='Call' || titleName==='Email'">
                        <div class="col-sm-12">
                          <h5>Comming Soon</h5>
                        </div>
                      </div>
                      <div class="col-sm-12" v-else>
                        <h5>Type of Damage:</h5>
                        <h6>
                          {{
                          item.type_of_damage
                          .map((element) => element)
                          .join(',')
                          }}
                        </h6>
                        <h5>Description:</h5>
                        <h6>{{ item.description }}</h6>
                      </div>
                      <template #header>
                        <h6 class="modal-title">Description</h6>
                      </template>
                      <template #footer>
                        <v-btn class="btn btn-danger" @click="informationDisplay = false">Cancel</v-btn>
                      </template>
                    </CModal>
                    <!-- vue information and reason modal end-->
                  </div>
                </CCardBody>
              </CCollapse>
            </td>
          </tr>
          <tr class="collaps-tr" v-if="innerCollaps">
            <td colspan="4">
              <p>Lorem Ipsum</p>
            </td>
          </tr>
          <CModal
            :show.sync="otherDamages && item.pictures_of_damage.length > 0"
            :no-close-on-backdrop="true"
            :centered="true"
            size="lg"
            color="dark"
          >
            <CCarousel arrows indicators animate height="650px">
              <CCarouselItem :image="item.pictures_of_damage[0]" />
              <CCarouselItem
                :image="item.pictures_of_damage[1]"
                height="450px"
                v-if="item.pictures_of_damage[1]"
              />
              <CCarouselItem
                :image="item.pictures_of_damage[2]"
                height="450px"
                v-if="item.pictures_of_damage[2]"
              />
              <CCarouselItem
                :image="item.pictures_of_damage[3]"
                height="450px"
                v-if="item.pictures_of_damage[3]"
              />
              <CCarouselItem
                :image="item.pictures_of_damage[4]"
                height="450px"
                v-if="item.pictures_of_damage[4]"
              />
            </CCarousel>
            <template #header>
              <h6 class="modal-title">Images of Damage</h6>
              <CButtonClose @click="otherDamages = false" />
            </template>
            <template #footer>
              <v-btn @click="otherDamages = false" class="btn btn-danger">Cancel</v-btn>
            </template>
          </CModal>

          <CModal
            :show.sync="revokeFlagModal"
            :no-close-on-backdrop="true"
            :centered="true"
            title="History"
            size="lg"
            color="dark"
          >
            <CTextarea
              label="Reason"
              v-model="remark"
              placeholder="Reason"
              horizontal
              rows="2"
              invalid-feedback="Please enter reason."
            />
            <template #header>
              <h6 class="modal-title">Reason for Approval</h6>
              <!-- <CButtonClose @click="revokeFlagModal = false" /> -->
            </template>
            <template #footer>
              <v-btn @click="revokeToggle(-1, false)" class="btn btn-danger">Cancel</v-btn>
              <v-btn
                @click="revokeRedFlag(redFlagList[revokedItemIndex])"
                class="btn btn-success"
              >Submit</v-btn>
            </template>
          </CModal>
        </tbody>
      </table>
      <pagination
        class="pagination-block"
        :recordPerPage="10"
        :currentPage="currentPage"
        :total="total"
        @changePage="changePage"
      />
    </div>
    <CModal
      :show.sync="warningModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Modal title 2"
      size="lg"
      color="dark"
    >
      <CTextarea
        label="Reason"
        v-model="reason"
        placeholder="Reason"
        horizontal
        rows="2"
        invalid-feedback="Please enter reason."
      />
      <template #header>
        <h6 class="modal-title">Reason for Reject</h6>
      </template>
      <template #footer>
        <v-btn class="btn btn-danger" @click="warningModal = false" color="danger">Cancel</v-btn>
        <v-btn
          class="btn btn-success"
          :disabled="!reason ? true : false"
          @click="setRedFlagStatus(inputJson, value)"
        >Submit</v-btn>
      </template>
    </CModal>
    <div>
      <light-box-new :images="lightbox_images" ref="lightbox"></light-box-new>
    </div>
  </div>
</template>
<script>
import { pickSvg } from "@/views/SVG";
import config from "@/config.js";
import Swal from "sweetalert2";
import formats from "@/formats";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .isBetween()
  .build();
import ChatMixin from "@/common/ChatMixin";
const LightBoxNew = () => import("@/components/lightBoxNew.vue");
const Pdf = () => import("@/components/pdf.vue");
import { mapGetters } from "vuex";
export default {
  mixins: [ChatMixin],
  computed: {
    ...mapGetters({
      permissions: "getPermissions"
    })
  },
  data() {
    return {
      formats,
      titleName: "",
      collaps: false,
      innerCollaps: false,
      status: "all",
      reason: "",
      warningModal: false,
      redFlagList: [],
      collapseDuration: 0,
      indexOfCollapse: [],
      currentPage: 1,
      totalPage: 1,
      search: "",
      otherDamages: false,
      informationDisplay: false,
      warningModal: false,
      inputJson: {},
      value: "",
      remark: "",
      revokeFlagModal: false,
      dayJS,
      lightbox_images: [],
      trial: false,
      file_type: "",
      filePdf: false,
      total: 0,
      revokedItemIndex: -1
    };
  },
  mounted() {
    this.getRedFlagList();
  },
  watch: {
    status: {
      handler(newValue) {
        this.redFlagList = [];
        this.indexOfCollapse.fill(false);
        this.getRedFlagList();
      }
    }
  },
  components: {
    "light-box-new": LightBoxNew,
    "pdf-component": Pdf,
    ...pickSvg("crossSVG"),
    pagination: () => import("@/views/common/Pagination")
  },
  methods: {
    clearSearch() {
      this.search = "";
    },
    revokeToggle(idx, flagModalSwitch) {
      this.revokedItemIndex = idx;
      this.revokeFlagModal = flagModalSwitch;
    },
    openInformationDisplay(data) {
      this.titleName = data;
      this.informationDisplay = true;
    },
    closeLightBox() {
      this.trial = false;
    },
    onFirModal(item, index) {
      if (item.fir_url) {
        this.file_type = item.fir_url[0].split(".").pop();
        if (this.file_type === "pdf") {
          this.filePdf = true;
        } else {
          this.filePdf = false;
          this.lightbox_images = [];
          for (let i = 0; i < item.fir_url.length; i++) {
            this.lightbox_images.push({
              src: item.fir_url[i],
              thumb: item.fir_url[i]
            });
          }
          this.$refs.lightbox.showImage(0);
          this.trial = true;
        }
      }
    },
    damageModal(item, index) {
      if (item.pictures_of_damage.length > 0) {
        this.file_type = item.pictures_of_damage[0].split(".").pop();
        if (this.file_type === "pdf") {
          this.filePdf = true;
        } else {
          this.filePdf = false;
          this.lightbox_images = [];
          for (let i = 0; i < item.pictures_of_damage.length; i++) {
            this.lightbox_images.push({
              src: item.pictures_of_damage[i],
              thumb: item.pictures_of_damage[i]
            });
          }
          this.$refs.lightbox.showImage(0);
          this.trial = true;
        }
      }
    },
    openSwal(item, val) {
      Swal.fire({
        title: "Are you sure",
        text: "You want to accept the red flag request?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, flag it!",
        cancelButtonText: "No"
      }).then(result => {
        if (result.isConfirmed) {
          this.setRedFlagStatus(item, val);
        }
      });
    },
    changePage(page) {
      this.currentPage = page.currentPage;
      this.getRedFlagList();
    },
    revokeRedFlag(item) {
      let url = `${config.BASE_URL}api/v2/admin/red-flag/revoke`;
      let payload = {
        record_no: item._id,
        remark: ""
      };
      this.$http
        .post(url, payload)
        .then(res => {
          this.revokeToggle(-1, false);
          this.getRedFlagList();
        })
        .catch(err => console.log(err));
    },
    setRedFlagStatus(item, status) {
      if (status == "reject" && !this.reason) {
        this.inputJson = item;
        this.value = status;
        this.warningModal = true;
        return;
      } else {
        let url = `${config.BASE_URL}api/v2/admin/red-flag/requests/accept-reject`;
        let payload = {
          record_no: item._id
        };
        if (status == "approve") {
          payload.is_valid = true;
        }
        if (status == "reject") {
          payload.is_valid = false;
        }
        payload.is_valid
          ? (payload.cancel_reason = "")
          : (payload.cancel_reason = this.reason);
        this.$http.post(url, payload).then(res => {
          if (res.body.status) {
            this.warningModal = false;
            this.getRedFlagList();
            this.file_type = "";
            this.filePdf = false;
            this.inputJson = {};
            this.value = "";
          }
        });
      }
    },
    getRedFlagList() {
      this.redFlagList = [];
      let url = `${config.BASE_URL}api/v2/admin/red-flag/requests/list`;
      let payload = {
        page_no: this.currentPage,
        records_per_page: 10,
        search_patient: this.search,
        status: this.status
      };
      this.$http.post(url, payload).then(res => {
        if (res.body.status) {
          this.totalPage = res.body.data.total_pages;
          this.redFlagList = res.body.data.list;
          this.total = res.body.data.total_records;
        }
      });
    },
    toggleDetails(item, index) {
      if (this.indexOfCollapse[index]) {
        this.file_type = "";
        this.filePdf = false;
        this.trial = false;
        this.indexOfCollapse.fill(false);

        this.$forceUpdate();
        this.$set(this.redFlagList[index], "_toggled", !item._toggled);
        this.collapseDuration = 300;
        this.$nextTick(() => {
          this.collapseDuration = 0;
        });
      } else {
        this.file_type = "";
        this.filePdf = false;
        this.trial = false;
        this.indexOfCollapse.fill(false);
        this.indexOfCollapse[index] = true;
        this.$forceUpdate();

        this.$set(this.redFlagList[index], "_toggled", !item._toggled);
        this.collapseDuration = 300;
        this.$nextTick(() => {
          this.collapseDuration = 0;
        });
      }
    }
  }
};
</script>
<style lang="scss">
.profile-info {
  .pro-info-main {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .profile-info-list {
      width: 33.33%;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      svg {
        width: 25px;
        margin-right: 18px;
        path {
          fill: #3c4b64;
        }
      }
    }
  }
}
.table {
  .btn-primary {
    color: #321fdb;
    background-color: transparent;
  }
  tr {
    &:last-child {
      td {
        border-bottom: 1px solid #d8dbe0;
      }
      h5 {
        margin: 0;
      }
      p {
        margin: 0;
      }
    }
  }
}
</style>